'use strict';

var React = require('react');
require('prop-types');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');
var Checkbox = require('../../node_modules/@material-ui/core/esm/Checkbox/Checkbox.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function CheckboxWithDay(_ref) {
  var defaultChecked = _ref.defaultChecked,
      handleCheckboxChange = _ref.handleCheckboxChange,
      dayOfWeek = _ref.dayOfWeek;
  return React__default["default"].createElement(Grid["default"], {
    container: true,
    alignItems: "center"
  }, React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(Checkbox["default"], {
    defaultChecked: defaultChecked,
    color: "default",
    value: "isChecked",
    onChange: function onChange(event) {
      return handleCheckboxChange(event);
    }
  })), React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: true
  }, React__default["default"].createElement(Typography["default"], {
    variant: "body1"
  }, dayOfWeek)));
}

CheckboxWithDay.defaultProps = {
  handleCheckboxChange: function handleCheckboxChange() {}
};

module.exports = CheckboxWithDay;
